import {jsx as _jsx} from "react/jsx-runtime";import {cn} from '../../../ui/cn'





export const BlockResizer = (props) => {
  const {className, onMouseDown} = props
  return (
    _jsx('div', {
      onMouseDown: onMouseDown,
      onTouchStart: onMouseDown,
      className: cn(
        'absolute top-0 flex h-full w-4 items-center justify-center opacity-0 transition-opacity group-hover:opacity-100',
        className
      ),
 children: 
      _jsx('div', { className: "h-[25%] w-1 cursor-col-resize rounded-3xl border-[1px] border-white/90 bg-slate-900/60"      ,})
    })
  )
}
